import * as z from "../../../vendor/zod/src/index";
export default z.object({
    issue_id: z.number(),
});
